import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import { useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import NotfoundScreen from "./screens/NotfoundScreen";
import HomeScreen from "./screens/Main/Home";
import OhYogaScreen from "./screens/OhYoga";
import Lenis from "@studio-freight/lenis";
import FreaturesScreen from "./screens/Features";
import TestScreen from "./screens/TestScreen";
import CompanyScreen from "./screens/Company";
import SidebarPage from "./screens/SidebarMenu";
import LandingPage from "./components/LandingPage";
import LandingALAB from "./screens/LandingPage/LandingAlab";

export default function App() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    if (lenis) {
      lenis.scrollTo(0, { duration: 2 });
    } else {
      console.error("Lenis is not available");
    }
  };

  useEffect(() => {
    AOS.init({});
  });

  const lenis = new Lenis({
    duration: 3,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  });

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  return (
    <BrowserRouter>
      <>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/profiel" element={<HomeScreen />} />
          <Route path="/home" element={<HomeScreen />} />
          <Route path="/home:id" element={<HomeScreen />} />
          <Route path="/ohyoga" element={<OhYogaScreen />} />
          <Route path="*" element={<NotfoundScreen />} />
          <Route path="/features" element={<FreaturesScreen />} />
          <Route path="/test" element={<TestScreen />} />
          <Route path="/Menu" element={<SidebarPage />} />
          <Route path="/company" element={<CompanyScreen />} />
          <Route path="/landing" element={<LandingPage />} />
          <Route path="/landingALAB" element={<LandingALAB />} />
        </Routes>
        <button
          className={`fixed bottom-8 right-8 z-50 p-3 rounded-full bg-blue-600 text-white shadow-lg transition-opacity ${
            isVisible ? "opacity-100" : "opacity-0"
          }`}
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          top
        </button>
      </>
    </BrowserRouter>
  );
}
